import { render, staticRenderFns } from "./PreOrderDetail.vue?vue&type=template&id=4f55c62a&scoped=true"
import script from "./PreOrderDetail.vue?vue&type=script&lang=js"
export * from "./PreOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./PreOrderDetail.vue?vue&type=style&index=0&id=4f55c62a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f55c62a",
  null
  
)

export default component.exports